/* eslint-disable no-restricted-syntax */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { Comment } from 'vendor/ckeditor/plugins/comment';
import { Task } from 'vendor/ckeditor/plugins/task';
import { FreezeDocumentCommand } from './freeze-document-command';
import { DocumentFreezeCommand } from './helpers';
import { UnFreezeDocumentCommand } from './un-freeze-document-command';

export class FreezeDocument extends Plugin {
  static get requires() {
    // Making sure that collaborative comments and task commands are already available in the editor.
    return [Comment, Task];
  }

  init() {
    const { editor } = this;

    editor.commands.add(
      DocumentFreezeCommand.Freeze,
      new FreezeDocumentCommand(this.editor),
    );

    editor.commands.add(
      DocumentFreezeCommand.UnFreeze,
      new UnFreezeDocumentCommand(this.editor),
    );
  }
}

export { DocumentFreezeCommand } from './helpers';
